import ctaLoggedOut from '@data/base/cta-logged-out.json'
import ctaLoggedOutVD from '@data/vde-fr/cta-logged-out.json'
import { createApi } from '@reduxjs/toolkit/query/react'
import { CtaConfiguration } from '@typesApp/Cta'
import { ContainerComponent } from '@typesApp/DynamicComponent'
import { ENDPOINTS } from '@constants/index'
import { transformCtaState } from '@utils/configurationTransform'
import { dbBaseQueryWithReauth } from './baseQuery'

const CONFIGURATIONS = {
  CTA_STATE: '/cta/state',
} as const

const BASE_URL = `${ENDPOINTS.DIRECT_BILLING.CONFIGURATIONS}?path=frontend-bundle`

export const configApi = createApi({
  reducerPath: 'configApi',
  baseQuery: dbBaseQueryWithReauth,
  keepUnusedDataFor: Number.MAX_VALUE,
  tagTypes: ['CtaInitialConfiguration', 'CtaConfiguration'],
  endpoints: builder => ({
    getCtaInitialConfiguration: builder.query<CtaConfiguration, string>({
      queryFn: async brand => {
        return { data: getInitialCtaConfiguration(brand) }
      },
      providesTags: [{ type: 'CtaInitialConfiguration' }],
    }),
    getCtaConfiguration: builder.query<CtaConfiguration, void>({
      query: () => ({
        url: `${BASE_URL}${CONFIGURATIONS.CTA_STATE}`,
        method: 'GET',
      }),
      transformResponse: (response: Record<string, Record<string, object>>): CtaConfiguration => {
        const result = transformCtaState(response.state)
        return result
      },
      providesTags: [{ type: 'CtaConfiguration' }],
    }),
  }),
})

export const { useGetCtaInitialConfigurationQuery, useGetCtaConfigurationQuery } = configApi

/**
 * Need to use the static json for loggedOut state as we cannot
 * fetch from configurations until customer is logged in
 */
const CTA_LOGGEDOUT_COMPONENT = {
  base: ctaLoggedOut,
  'vde-fr': ctaLoggedOutVD,
} as Record<string, ContainerComponent>

const getInitialCtaConfiguration = (brand: string): CtaConfiguration => {
  return {
    loggedOut: CTA_LOGGEDOUT_COMPONENT[brand] || CTA_LOGGEDOUT_COMPONENT.base,
  } as CtaConfiguration
}
